<template>
	<div>
		<BaseActionBar v-if="isAdmin" :items="actions" />

		<UserListTable
			:is-loading="isLoading"
			:items="tableData"
			:pagination="pagination"
		/>
	</div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import UserListTable from '../components/UserListTable.vue';
import { ROUTER_NAME } from '../enums/router';

export default {
	name: 'UserList',

	components: {
		UserListTable,
	},

	data() {
		return {
			actions: [
				{
					to: { name: ROUTER_NAME.USER_CREATE },
					icon: ['far', 'plus'],
					color: 'secondary',
					text: this.$t('button.create_user'),
				},
			],
		};
	},

	computed: {
		...mapState('userList', {
			isLoading: 'isLoading',
			pagination: 'pagination',
		}),
		...mapGetters('userList', {
			tableData: 'tableData',
		}),
		...mapGetters('me', {
			isAdmin: 'isAdmin',
		}),
	},

	created() {
		this.fetchData();
	},

	methods: {
		...mapActions('userList', {
			getUsers: 'getUsers',
		}),
		fetchData() {
			this.getUsers();
		},
	},
};
</script>